import React, { useEffect, useState } from 'react';
import { Search, MapPin, Menu, X, ChevronDown, Phone } from 'lucide-react';
import { navMenu } from '../mock';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className="sticky top-0 z-50 w-full bg-white">
      {/* Top utility bar */}
      <div className="hidden md:flex items-center justify-end gap-6 px-8 py-2 text-[11px] tracking-wider uppercase text-[#6b6b6b] border-b border-neutral-100">
        <a href="#" className="hover:text-[#7a1a2a] transition-colors">Our Story</a>
        <a href="#" className="hover:text-[#7a1a2a] transition-colors">News & Media</a>
        <a href="#" className="hover:text-[#7a1a2a] transition-colors">Export Enquiry</a>
        <a href="#" className="hover:text-[#7a1a2a] transition-colors">Career</a>
        <a href="#" className="hover:text-[#7a1a2a] transition-colors">Warranty</a>
        <span className="flex items-center gap-1 text-[#7a1a2a]"><Phone className="w-3 h-3" /> +91 9979111925</span>
      </div>

      {/* Main nav */}
      <div className={`flex items-center justify-between px-6 md:px-10 transition-all ${scrolled ? 'py-2' : 'py-4'} border-b border-neutral-100`}>
        {/* Logo */}
        <a href="/" className="flex items-center gap-3 shrink-0">
          <img src="/images/logo.png" alt="Indian Ceramic" className="h-14 md:h-16 w-auto object-contain" />
        </a>

        {/* Center menu */}
        <nav className="hidden lg:flex items-center gap-7">
          {navMenu.map((item) => (
            <div key={item.label} className="group relative">
              <button className="flex items-center gap-1 text-[13px] tracking-wider uppercase text-[#1a1a1a] hover:text-[#7a1a2a] transition-colors py-2">
                {item.label}
                {item.sub && <ChevronDown className="w-3 h-3" />}
              </button>
              {item.sub && (
                <div className="absolute left-1/2 -translate-x-1/2 top-full mt-0 w-52 bg-white border border-neutral-100 shadow-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
                  {item.sub.map((s) => (
                    <a key={s} href="#" className="block px-4 py-3 text-[12px] tracking-wide uppercase text-[#1a1a1a] hover:bg-[#f6f1ea] hover:text-[#7a1a2a] transition-colors border-b border-neutral-50 last:border-0">{s}</a>
                  ))}
                </div>
              )}
            </div>
          ))}
        </nav>

        {/* Right icons */}
        <div className="flex items-center gap-4">
          <button aria-label="Search" className="p-2 hover:text-[#7a1a2a] transition-colors"><Search className="w-5 h-5" /></button>
          <button aria-label="Locate" className="hidden md:flex items-center gap-1 p-2 hover:text-[#7a1a2a] transition-colors">
            <MapPin className="w-5 h-5" />
            <span className="text-[11px] uppercase tracking-wider">Store Locator</span>
          </button>
          <button className="hidden md:inline-flex bg-[#7a1a2a] hover:bg-[#5a1220] text-white text-[11px] tracking-[0.15em] uppercase px-5 py-3 transition-colors">Enquire Now</button>
          <button onClick={() => setMobileOpen(true)} className="lg:hidden p-2" aria-label="Menu"><Menu className="w-6 h-6" /></button>
        </div>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="fixed inset-0 z-50 bg-white lg:hidden">
          <div className="flex items-center gap-3 px-6 py-4 border-b">
            <img src="/images/logo.png" alt="Indian Ceramic" className="h-10 w-auto object-contain" />
            <button onClick={() => setMobileOpen(false)} aria-label="Close" className="ml-auto"><X className="w-6 h-6" /></button>
          </div>
          <div className="flex flex-col p-6 gap-4">
            {navMenu.map((m) => (
              <a key={m.label} href="#" className="text-base uppercase tracking-wider border-b border-neutral-100 py-2">{m.label}</a>
            ))}
            <button className="mt-4 bg-[#7a1a2a] text-white py-3 uppercase text-sm tracking-wider">Enquire Now</button>
          </div>
        </div>
      )}
    </header>
  );
}
